<section>
  <app-breadcrumb [label]="titleBreadcrumbs"></app-breadcrumb>

  <div class="section__main section__main--reports">
    <div class="section__title pb-15">
      <h1>Reporte de ventas con productos adicionales</h1>
    </div>

    <div class="reports">
      <div class="reports__tableComp">
        <div class="reports__table table--fullHeight table--fullAdaptable">

          <!-- Header -->
          <div class="reports__tableHeader">
            <h3>Todas las ventas</h3>
          </div>

          <!-- Filters -->
          <div class="reports__tableFilters reports__tableFilters--sales">
            <div class="filters__date">
              <div class="filters__title">
                <h4>Filtrar por período</h4>
              </div>
              <div class="filters__dateBlock">
                <div class="filters__dateGroup">
                  <div class="filters__dateField">
                    <label class="filters__dateLabel">Fecha:</label>
                    <p-calendar [(ngModel)]="selectedDate" view="month" dateFormat="MM yy" [readonlyInput]="true" [showIcon]="true" panelStyleClass="filters__dateCustom" appendTo="body" placeholder="Seleccionar..." styleClass="filters__dateCalendar"></p-calendar>
                  </div>
                </div>

                <div class="filters__dateActions">
                  <div class="filters__dateButton">
                    <button pButton pRipple label="Filtrar" class="p-button-secondary p-button-raised p-button-rounded n-background n-shadow" (click)="loadSalesReport()"></button>
                  </div>
                  <div class="filters__dateButton">
                    <p-button label="Limpiar" icon="pi pi-trash" iconPos="right" [text]="true" [plain]="true" (onClick)="clearFilters()"></p-button>
                  </div>
                </div>
              </div>
            </div>

            <div class="filters__switch">
              <div class="filters__title">
                <h4>¿Tiene productos adicionales?</h4>
              </div>
              
              <div class="filters__switchBlock">
                <div class="filters__switchBtns">
                  <p-selectButton [options]="additionalProductFilterOptions" [(ngModel)]="additionalProductFilter" optionLabel="label" optionValue="value" (onChange)="applyAdditionalProductFilter()"></p-selectButton>
                </div>
              </div>
            </div>
          </div>

          <!-- Datatable -->
          <div class="reports__tableDatatable">
            <p-table #dt [value]="filteredRows" [paginator]="true" [rows]="15" [rowsPerPageOptions]="[15, 30, 50]" [scrollable]="true" [globalFilterFields]="globalFilterFields" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros">

              <ng-template pTemplate="header">
                <tr class="p-datatable-titles">
                  <th *ngFor="let column of visibleColumns" [pSortableColumn]="column.field" [style.min-width]="column.minWidth">
                    <div class="th-title">
                      <span>{{ column.header }}</span>
                      <p-sortIcon [field]="column.field"></p-sortIcon>
                    </div>
                  </th>
                </tr>

                <!-- Filter Titles -->
                <tr class="p-datatable-filters">
                  <th *ngFor="let column of visibleColumns">
                    <ng-container [ngSwitch]="column.type">
                      
                      <div class="th-filter" *ngSwitchCase="'date'">
                        <p-calendar [ngModel]="columnFilterValues[column.field]" (onSelect)="applyColumnFilter(dt, column.field, $event, 'dateIs')" (onClear)="applyColumnFilter(dt, column.field, null, 'dateIs')" (onClearClick)="applyColumnFilter(dt, column.field, null, 'dateIs')" dateFormat="dd/mm/yy" [showIcon]="true" [readonlyInput]="true" [showButtonBar]="true" styleClass="p-datatable-filters__columnDatePicker" panelStyleClass="filters__dateCustom" appendTo="body"></p-calendar>
                      </div>

                      <div class="th-filter" *ngSwitchCase="'datetime'">
                        <p-calendar [ngModel]="columnFilterValues[column.field]" (onSelect)="applyColumnFilter(dt, column.field, $event, 'dateIs')" (onClear)="applyColumnFilter(dt, column.field, null, 'dateIs')" (onClearClick)="applyColumnFilter(dt, column.field, null, 'dateIs')" dateFormat="dd/mm/yy" [showIcon]="true" [readonlyInput]="true" [showButtonBar]="true" styleClass="p-datatable-filters__columnDatePicker" panelStyleClass="filters__dateCustom" appendTo="body"></p-calendar>
                      </div>

                      <div class="th-filter" *ngSwitchCase="'boolean'">
                        <p-dropdown [ngModel]="columnFilterValues[column.field]" [options]="booleanFilterOptions" optionLabel="label" optionValue="value" placeholder="Todos" [showClear]="true" styleClass="p-datatable-filters__columnDropdown" (onChange)="applyColumnFilter(dt, column.field, $event.value, 'equals')"></p-dropdown>
                      </div>

                      <div class="th-filter" *ngSwitchCase="'status'">
                        <p-dropdown [ngModel]="columnFilterValues[column.field]" [options]="getStatusFilterOptions(column)" optionLabel="label" optionValue="value" placeholder="Todos" styleClass="p-datatable-filters__columnDropdown" (onChange)="applyColumnFilter(dt, column.field, $event.value, 'equals')"></p-dropdown>
                      </div>

                      <div class="th-filter" *ngSwitchCase="'numeric'">
                        <span class="p-input-icon-right p-datatable-filters__columnSearch">
                          <input pInputText type="number" [ngModel]="columnFilterValues[column.field]" (input)="applyStartsWithColumnFilter(dt, column.field, $any($event.target).value)"/>
                          <i class="pi pi-search"></i>
                        </span>
                      </div>

                      <div class="th-filter" *ngSwitchCase="'currency'">
                        <span class="p-input-icon-right p-datatable-filters__columnSearch">
                          <input pInputText type="number" [ngModel]="columnFilterValues[column.field]" (input)="applyStartsWithColumnFilter(dt, column.field, $any($event.target).value)"/>
                          <i class="pi pi-search"></i>
                        </span>
                      </div>

                      <div class="th-filter" *ngSwitchCase="'percent'">
                        <span class="p-input-icon-right p-datatable-filters__columnSearch">
                          <input pInputText type="number" [ngModel]="columnFilterValues[column.field]" (input)="applyStartsWithColumnFilter(dt, column.field, $any($event.target).value)"/>
                          <i class="pi pi-search"></i>
                        </span>
                      </div>

                      <div class="th-filter" *ngSwitchDefault>
                        <span class="p-input-icon-right p-datatable-filters__columnSearch">
                          <input pInputText type="text" [ngModel]="columnFilterValues[column.field]" (input)="applyStartsWithColumnFilter(dt, column.field, $any($event.target).value)"/>
                          <i class="pi pi-search"></i>
                        </span>
                      </div>
                    </ng-container>
                  </th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-row>
                <tr class="p-datatable-content">
                  <td *ngFor="let column of visibleColumns" [style.min-width]="column.minWidth">
                    <div class="td-text" [ngClass]="['td-text--' + column.align, column.bold ? 'td-text--bold' : '']">
                      <ng-container [ngSwitch]="column.type">
                        
                        <ng-container *ngSwitchCase="'status'">
                          <ng-container [ngSwitch]="column.field">
                            <div *ngSwitchCase="'paymentStatus'" class="appliedPay-tag" [ngClass]="'appliedPay-tag--' + getStatusSeverity(row[column.field])">
                                <i [class]="getAllyPaymentIcon(getStatusSeverity(row[column.field]))"></i>
                              <span>{{ displayValue(row, column) }}</span>
                            </div>

                            <div *ngSwitchDefault class="status-tag" [ngClass]="'status-tag--' + getStatusSeverity(row[column.field])">
                              <span>{{ displayValue(row, column) }}</span>
                            </div>
                          </ng-container>
                        </ng-container>

                        <p *ngSwitchDefault>{{ displayValue(row, column) }}</p>
                        
                      </ng-container>
                    </div>
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr class="p-datatable-content">
                  <td [attr.colspan]="visibleColumnCount">
                    <div class="td-empty">
                      <p>No hay ventas para mostrar.</p>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
